// See web/app/themes/jcf-theme/acf/news-module.twig

import "slick-carousel";
import $ from "jquery";

class NewsCarousel {
  init() {
    let $buttons = $('[data-carousel="quotes-nav"] [data-slide]');

    $(document).ready(function () {
      $('[data-carousel="quotes"]')
        .slick({
          dots: false,
          arrows: false,
          mobileFirst: true,
          fade: true,
          infinite: true,
        })
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          $buttons
            .eq(nextSlide)
            .addClass("active")
            .siblings()
            .removeClass("active");
        });

      $buttons.hover(function (event) {
        event.preventDefault();
        var slide = $(this).data("slide");
        $(this).addClass("active").siblings().removeClass("active");
        $('[data-carousel="quotes"]').slick("slickGoTo", slide - 1);
      });
    });
  }
}

export default NewsCarousel;
